import { TextAreaWidget } from "Components/optionForm";
import styles from "./NeuralInterfaceInput.module.css";
import { Button } from "UiKit";
import React, { useEffect, useState } from "react";
import { useNeuralInterfaceContext } from "../NeuralInterfaceContext";
import isString from "lodash/isString";
import VoiceRecorder from "UiKit/VoiceRecorder/VoiceRecorder";
function NeuralInterfaceInput({ updatesNeural, clearUpdates }) {
    const { recognizeText, activeInput, voiceRecorderRef, addVoiceRecord, addText } = useNeuralInterfaceContext();
    const [text, setText] = useState(recognizeText);
    const sendText = () => {
        addText(text);
        setText(undefined);
    };
    useEffect(() => {
        var _a, _b, _c;
        const textObj = updatesNeural.find(item => item.NodeSource.DocumentObjectId === "socrat.text");
        if (textObj === null || textObj === void 0 ? void 0 : textObj.NodeSource.AttributeValues) {
            const newText = (_b = (_a = textObj.NodeSource.AttributeValues.find(item => item.Key === "socrat.text")) === null || _a === void 0 ? void 0 : _a.Value) !== null && _b !== void 0 ? _b : (_c = textObj.NodeSource.AttributeValues.find(item => item.Key === "PT10000")) === null || _c === void 0 ? void 0 : _c.Value;
            if (isString(newText)) {
                setText(newText);
                clearUpdates([textObj.Key]);
            }
        }
    }, [updatesNeural]);
    useEffect(() => {
        setText(recognizeText);
    }, [recognizeText]);
    return (React.createElement("div", { className: styles.container },
        React.createElement(Button, { className: styles.icon, iconOnly: true, styleType: "text", size: "36", onClick: () => {
                var _a;
                (_a = voiceRecorderRef === null || voiceRecorderRef === void 0 ? void 0 : voiceRecorderRef.current) === null || _a === void 0 ? void 0 : _a.togglePauseResume();
            } },
            React.createElement("i", { className: "icon-stars" })),
        activeInput === "Input" ? (React.createElement(React.Fragment, null,
            React.createElement(TextAreaWidget, { stylingMode: "underlined", autoResizeEnabled: true, value: text, onChange: setText, className: styles["dx-input"], placeholder: "\u041F\u043E\u0438\u0441\u043A \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0438\u043B\u0438 \u0432\u0432\u043E\u0434 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438", minHeight: 36, inputAttr: { inputmode: "text", autocomplete: "off" }, onKeyDown: ({ event }) => {
                    if (event && event.key === "Enter" && !event.shiftKey) {
                        event.preventDefault();
                        sendText();
                    }
                } }),
            React.createElement(Button, { className: styles.button, iconOnly: true, styleType: "filled", size: "36", onClick: sendText },
                React.createElement("i", { className: "icon-arrow-left-bottom-right" })))) : (React.createElement(VoiceRecorder, { ref: voiceRecorderRef, className: styles["voice-input"], height: 36, startRecordingOnInit: true, onFileChange: addVoiceRecord, maxRecordingTime: 30000, outputFormat: "ogg" }))));
}
export default NeuralInterfaceInput;
